module.exports = __webpack_public_path__ + "img/vector__mobile.e8ea77e1.svg";